import React from "react";
import { Lock } from "lucide-react";
import { useAuth } from "../lib/auth";

export const fmtUntil = (until) => until ? new Date(until).toLocaleString() : "permanently";

export default function LockedScreen() {
  const { locked, logout } = useAuth();
  return (
    <div data-testid="account-locked-screen" className="min-h-screen flex items-center justify-center bg-[#0A051A] px-4">
      <div className="max-w-md w-full rounded-2xl border-2 border-[#FF007F] bg-[#12082B] p-8 text-center" style={{ boxShadow: "0 0 30px #FF007F55" }}>
        <Lock className="mx-auto mb-4 text-[#FF007F]" size={40} />
        <div className="font-heading text-2xl neon-pink mb-2">ACCOUNT LOCKED</div>
        <div data-testid="account-locked-until" className="font-mono text-sm text-[#A89BCC] mb-4">
          {locked?.until ? `Locked until ${fmtUntil(locked.until)}` : "This account is locked permanently."}
        </div>
        <div className="font-mono text-xs text-[#A89BCC] uppercase tracking-widest mb-1">Reason</div>
        <div data-testid="account-locked-reason" className="font-mono text-sm text-white mb-6 break-words">{locked?.reason || "No reason given"}</div>
        <button data-testid="account-locked-logout" onClick={logout} className="btn-neon text-xs">Back to login</button>
      </div>
    </div>
  );
}
